import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

export const DEFAULT_COUNTRY_CODE = 'US';

const phoneUtil = PhoneNumberUtil.getInstance();

function parsePhoneNumber(phoneNumber) {
  return typeof phoneNumber === 'string' ? phoneUtil.parseAndKeepRawInput(phoneNumber) : phoneNumber;
}

export function formatNumber(phoneNumber) {
  return phoneUtil.format(parsePhoneNumber(phoneNumber), PhoneNumberFormat.E164);
}

export function isValidNumber(phoneNumber) {
  try {
    return !!phoneNumber && phoneUtil.isValidNumber(parsePhoneNumber(phoneNumber));
  } catch {
    return false;
  }
}

export function separateFormattedNumber(formattedPhoneNumber) {
  const number = parsePhoneNumber(formattedPhoneNumber);
  return {
    countryCode: phoneUtil.getRegionCodeForNumber(number),
    nationalNumber: phoneUtil.format(number, PhoneNumberFormat.NATIONAL),
  };
}

export function parseAsYouType(phoneNumber, countryCode = DEFAULT_COUNTRY_CODE) {
  if (!phoneNumber) return undefined;
  try {
    const number = phoneUtil.parseAndKeepRawInput(phoneNumber, countryCode);
    return {
      countryCode: phoneUtil.getRegionCodeForNumber(number) || countryCode,
      nationalNumber: `${number.getNationalNumber()}`,
    };
  } catch (e) {
    return undefined;
  }
}
